// import { Aes } from '@/shared/lib/secure-json/core/crypto-core/aes';
// import { Rsa } from '@/shared/lib/secure-json/core/crypto-core/rsa';
// import { Ecies } from '@/shared/lib/secure-json/core/crypto-core/ecies';
import * as libCrypto from '@ownerone/lib-crypto';

import { decryptFile, encryptFile } from './files';
import { AsymmetricEncryption, EncryptionType, KeyPair } from './types';

interface ICryptoCore {
  asymmetric: AsymmetricEncryption;
  // static aes: typeof libCrypto.aes;
}

export class CryptoCore implements ICryptoCore {
  public static aes = libCrypto.aes;
  public static files = {
    decrypt: decryptFile,
    encrypt: encryptFile,
  };
  public readonly asymmetric: AsymmetricEncryption;

  constructor(type?: EncryptionType) {
    this.asymmetric = type === 'ecies' ? libCrypto.ecies : libCrypto.rsa;
  }

  public static encryptMnemonic(mnemonic: string, password: string): string {
    return CryptoCore.aes.encrypt(mnemonic, password);
  }

  public static decryptMnemonic(mnemonic: string, password: string): string {
    return CryptoCore.aes.decrypt(mnemonic, password);
  }

  /**
   * @deprecated Use OPRF and clientSalt
   */
  public async encryptedMnemonicToKeyPair(
    encryptedMnemonic: string,
    password: string,
  ): Promise<KeyPair> {
    const mnemonic = CryptoCore.decryptMnemonic(encryptedMnemonic, password);
    return await this.mnemonicToKeyPair(mnemonic);
  }

  public async mnemonicToKeyPair(mnemonic: string): Promise<KeyPair> {
    return await this.asymmetric.mnemonicToKeyPair(mnemonic);
  }

  /**
   * @deprecated Use public static CryptoCore.files.decryptFile
   */
  public decryptFile = decryptFile;
  /**
   * @deprecated Use public static CryptoCore.files.encryptFile
   */
  public encryptFile = encryptFile;
}
